/** Auto-Generated File **/
import {HistoricalEntityEnum} from '../models/enums/field-history/historical-entity-enum';
import {EnumTraslationKeysEnum} from '../models/enums/enum-traslation-keys-enum';
import {AppointmentHistoricalFieldsEnum} from '../models/enums/field-history/appointment-historical-fields-enum';
import {InsuranceHistoricalFieldsEnum} from '../models/enums/field-history/insurance-historical-fields-enum';
import {SalesOrderHistoricalFieldsEnum} from '../models/enums/field-history/sales-order-historical-fields-enum';
import {SalesOrderLineHistoricalFieldsEnum} from '../models/enums/field-history/sales-order-line-historical-fields-enum';
import {SerializedItemHistoricalFieldsEnum} from '../models/enums/field-history/serialized-item-historical-fields-enum';
import { EndOfDayHistoricalFieldsEnum } from '../models/enums/field-history/end-of-day-historical-fields-enum';

class HistoricalFields {
	readonly appointment = AppointmentHistoricalFieldsEnum;
	readonly insurance = InsuranceHistoricalFieldsEnum;
	readonly salesOrder = SalesOrderHistoricalFieldsEnum;
	readonly salesOrderLine = SalesOrderLineHistoricalFieldsEnum;
	readonly serializedItem = SerializedItemHistoricalFieldsEnum;
	readonly endofday = EndOfDayHistoricalFieldsEnum;
}

export class HistoryHelper {

	static readonly instance = new HistoryHelper();

	private constructor() {}

	readonly entity = HistoricalEntityEnum;

	readonly enumTranslationKey = EnumTraslationKeysEnum;

	readonly fields = new HistoricalFields();

}